import script from "./BellSugestoes.vue?vue&type=script&setup=true&lang=js"
export * from "./BellSugestoes.vue?vue&type=script&setup=true&lang=js"

import "./BellSugestoes.vue?vue&type=style&index=0&id=890ba608&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-890ba608"]])

export default __exports__